import React, {Component} from "react";
import {connect} from "react-redux";

import * as navigationActions from "../../../actions/navigationActions";

import NotificationPanelComponent from "../../../components/apps/default/NotificationPanel";

class NotificationPanel extends Component {
    render() {
        return (
            <NotificationPanelComponent
                activeNotificationPanel={this.props.activeNotificationPanel}
                notificationList={this.props.notificationList}
                deleteAllFlashMessages={this.props.dispatchDeleteAllFlashMessagesAction}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        activeNotificationPanel: store.navigation.activeNotificationPanel,
        notificationList: store.navigation.flashMessages
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchDeleteAllFlashMessagesAction: () => {
            dispatch(navigationActions.deleteAllFlashMessages());
        }
    };
};

export default NotificationPanel = connect(mapStoreToProps, mapDispatchToProps)(NotificationPanel);
